import "./Stripbanner.css";

function Stripbanner() {
  return (
    <section className="stripbanner">
      <div className="stripbanner__inner">
        <p className="stripbanner__text">
          I'm now offering a complete full-stack development service on Fastwork.co.
        </p>
        <a
          className="stripbanner__btn"
          href="https://fastwork.co/user/vasapon/web-development-93446952/"
          target="_blank"
          rel="noreferrer"
        >
          Learn More
        </a>
      </div>
    </section>
  );
}

export default Stripbanner;
